import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-46578a22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "nav-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(!_ctx.isAsideWidth ? 'logo' : 'img-center')
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("span", _hoisted_3, "Vue3+Ts", 512), [
        [_vShow, !_ctx.isAsideWidth]
      ])
    ], 2),
    _createVNode(_component_el_menu, {
      mode: "vertical",
      "default-active": _ctx.actNum,
      class: "el-menu-vertical-demo",
      "background-color": "#001529",
      "text-color": "#b7bdc3",
      onSelect: _ctx.activeSelect,
      collapse: _ctx.isAsideWidth
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userMenus.slice(0, 3), (root) => {
          return (_openBlock(), _createBlock(_component_el_sub_menu, {
            index: root.id + '',
            key: root.id
          }, {
            title: _withCtx(() => [
              (_ctx.getIcon(root.icon))
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIcon(root.icon))))
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(root.name), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(root.children, (child) => {
                return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                  index: child.id + '',
                  key: child.id,
                  class: _normalizeClass(_ctx.actNum == child.id ? 'active-bgc' : ''),
                  onClick: ($event: any) => (_ctx.menuItemClick(child))
                }, {
                  title: _withCtx(() => [
                    (_ctx.getIcon(child.icon))
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIcon(child.icon))))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(child.name), 1)
                  ]),
                  _: 2
                }, 1032, ["index", "class", "onClick"])), [
                  [_vShow, child.id !== 39 && child.id !== 3 && child.id !== 15]
                ])
              }), 128))
            ]),
            _: 2
          }, 1032, ["index"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active", "onSelect", "collapse"])
  ]))
}